import { render, staticRenderFns } from "./ProductFinder.vue?vue&type=template&id=08456768&scoped=true"
import script from "./ProductFinder.vue?vue&type=script&lang=ts"
export * from "./ProductFinder.vue?vue&type=script&lang=ts"
import style0 from "./ProductFinder.vue?vue&type=style&index=0&id=08456768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08456768",
  null
  
)

export default component.exports